import { render, staticRenderFns } from "./CollectionProgress.vue?vue&type=template&id=b9bb2398"
import script from "./CollectionProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionProgress.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports